export default "__VITE_ASSET__BB0nF5ql__"